"use client";

import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { SplitText } from "gsap/all";

const FlavorTitle = () => {
  useGSAP(() => {
    const firstTextSplit = SplitText.create(".first-text-split h1", {
      type: "words,chars",
    });
    const secondTextSplit = SplitText.create(".second-text-split h1", {
      type: "words,chars",
    });
    const thirdTextSplit = SplitText.create(".third-text-split h1", {
      type: "words,chars",
    });

    gsap.from(firstTextSplit.chars, {
      yPercent: 200,
      stagger: 0.06,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".flavor-section",
        start: "top 60%",
      },
    });

    gsap.from(secondTextSplit.chars, {
      yPercent: 200,
      stagger: 0.06,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".flavor-section",
        start: "top 55%",
      },
    });

    gsap.from(thirdTextSplit.chars, {
      yPercent: 200,
      stagger: 0.06,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: ".flavor-section",
        start: "top 50%",
      },
    });

    return () => {
      firstTextSplit.revert();
      secondTextSplit.revert();
      thirdTextSplit.revert();
    };
  });

  return (
    <div className="col-center h-full">
      <div className="overflow-hidden 2xl:py-0 py-2 first-text-split w-full max-w-none md:max-w-[50rem] text-center px-4 md:px-0">
        <h1 className="text-[#523122] md:text-[100px] text-[10vw] leading-none font-bold text-center whitespace-normal md:whitespace-nowrap break-keep">
          India’s only cartel
        </h1>
      </div>
      <div className="overflow-hidden 2xl:py-0 py-2 second-text-split w-full max-w-none md:max-w-[50rem] text-center mt-[-0.4rem] md:mt-[-1rem] px-4 md:px-0">
        <h1 className="text-[#523122] md:text-[100px] text-[10vw] leading-none font-bold text-center whitespace-normal md:whitespace-nowrap break-keep">
          serving the entire
        </h1>
      </div>
      <div className="overflow-hidden 2xl:py-0 py-2 third-text-split w-full max-w-none md:max-w-[60rem] text-center mt-[-0.4rem] md:mt-[-1rem] px-4 md:px-0">
        <h1 className="text-[#523122] md:text-[100px] text-[10vw] leading-none font-bold text-center whitespace-normal md:whitespace-nowrap break-keep">
          Kunafa Universe
        </h1>
      </div>
    </div>
  );
};

export default FlavorTitle;
